import * as yup from "yup"

export const leyAntifraudeFormRepresentantesFormTemplateSchema = () =>
  yup.object().shape({
    empresa_nif: yup.string().required("El NIF es obligatorio"),
    empresa_razonSocial: yup
      .string()
      .required("La razón social es obligatoria"),
    empresa_calle: yup.string().required("La calle es obligatoria"),
    empresa_numero: yup
      .string()
      .required("El número de la calle es obligatorio"),
    empresa_municipio: yup.string().required("El municipio es obligatorio"),
    representantes: yup
      .array()
      .of(
        yup.object().shape({
          nombreCompleto: yup
            .string()
            .required("El nombre completo es obligatorio"),
          nif: yup.string().required("El NIF es obligatorio"),
          calle: yup.string().required("La calle es obligatoria"),
          numero: yup.string().required("El número de la calle es obligatorio"),
          municipio: yup.string().required("El municipio es obligatorio"),
        })
      )
      .min(1, "Debe haber al menos un representante")
      .required("Los representantes son obligatorios"),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) as any
